import React from "react";
import dynamic from "next/dynamic";
//import "react-responsive-carousel/lib/styles/carousel.min.css";
//import { Carousel } from "react-responsive-carousel";
import styles from "../../styles/pages/emptwin.module.scss";
//import Icons from "../../../public/assets/svg/index";
const Icons = dynamic(() => import("../../public/assets/svg/index"));
//import Card from "../../dynamicBotCard";
const Card = dynamic(() => import("../dynamicTwinCard"));
//import Slider from "react-slick";
import Carousels from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
//import Dropdown from "../../listWithoutcheck";
import endpoints from "../../utility/endpoints";
//import BasicForm from "../../basicForm";
//const BasicForm = dynamic(() => import("../../basicForm"));
const BasicForm = dynamic(() => import("../basicForm"));
//import Video from "../../../pages/videoModal";
const Video = dynamic(() => import("../../pages/emptwinvideoModal"));
const Empbanner = dynamic(() => import("../emptwinBanner"));
const Empbanner1 = dynamic(() => import("../emptwin1Banner"));
const Filters = dynamic(() => import("../Filtersemptwin"));
import _get from "lodash/get";
import { useRouter } from "next/router";
import ReactPlayer from "react-player";
import axios from "axios";
import { useState, useEffect } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
const SuccessModal = dynamic(() => import("../../pages/successModal"));
import { useMediaQuery } from "react-responsive";
//import Loader from "./../../Loader";
const Loader = dynamic(() => import("../Loader"));
import ExperienceemptwinModal from "../Pages/ExperienceemptwinModal";

//import DropDown from "../../listWithoutcheck";
//url={`https://newbotstore.blob.core.windows.net/botstorevideo/${myBot.ktV`ideo}`}
// helper component for carousels
import { sessionTimeOutCheck, checkExpiry } from "../../redux/global/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

const responsive1 = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 1,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    partialVisibilityGutter: 160,
  },
};

const responsive2 = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 3,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 768, min: 0 },
    items: 1,
    partialVisibilityGutter: 40,
  },
};

const responsive3 = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 4,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 768, min: 0 },
    items: 1,
    partialVisibilityGutter: 40,
  },
};

var arr = ["", "", "", "", ""];

const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
  const {
    carouselState: { currentSlide },
  } = rest;

  return (
    <div
    // className="carousel-button-group position-absolute w-100"
    // style={{ top: "345px" }}
    >
      <span
        className={currentSlide === 0 ? styles.customprev : styles.customprev}
        onClick={() => previous()}
      >
        <LazyLoadImage src="/assets/svg/Lefti.png" />
      </span>
      <span className={styles.customnext} onClick={() => next()}>
        <LazyLoadImage src="/assets/svg/righti.png" />
      </span>
    </div>
  );
};
const ButtonGroup2 = ({ next, previous, goToSlide, ...rest }) => {
  const {
    carouselState: { currentSlide },
  } = rest;

  return (
    <div>
      <span
        className={
          currentSlide === 0 ? styles.customprevguest : styles.customprevguest
        }
        onClick={() => previous()}
      >
        <LazyLoadImage src="/assets/svg/Lefti.png" />
      </span>
      <span className={styles.customnextguest} onClick={() => next()}>
        <LazyLoadImage src="/assets/svg/righti.png" />
      </span>
    </div>
  );
};

const ButtonGroupmain = ({ next, previous, goToSlide, ...rest }) => {
  const {
    carouselState: { currentSlide },
  } = rest;

  return (
    <div
    // className="carousel-button-group position-absolute w-100"
    // style={{ top: "345px" }}
    >
      <span
        className={
          currentSlide === 0 ? styles.customprevmain : styles.customprevmain
        }
        onClick={() => previous()}
      >
        <LazyLoadImage src="/assets/svg/Left-navigation-active.png" />
      </span>
      <span className={styles.customnextmain} onClick={() => next()}>
        <LazyLoadImage src="/assets/svg/Right-navigation-active.png" />
      </span>
    </div>
  );
};

const CustomDot = ({ onClick, ...rest }) => {
  const { index, active } = rest;
  //  alert(active)
  const carouselItems = arr;
  return (
    <span
      className={
        active == true
          ? styles.dotActive + " " + styles.reactMultiCarouselDot
          : styles.dotInactive + " " + styles.reactMultiCarouselDot
      }
      onClick={() => onClick()}
    >
      {/* {console.log("active", active)}
      {React.Children.toArray(carouselItems)[index]} */}
    </span>
  );
};
const CustomDot1 = ({ onClick, ...rest }) => {
  const { index, active } = rest;

  const carouselItems = arr;
  return (
    <span
      className={
        active == true
          ? styles.dotActive + " " + styles.reactMultiCarouselDot
          : styles.dotInactive + " " + styles.reactMultiCarouselDot
      }
      onClick={() => onClick()}
    >
      {/* {console.log("active", active)}
      {React.Children.toArray(carouselItems)[index]} */}
    </span>
  );
};

// real home component starts from here

function index(props) {
  const router = useRouter();
  //console.log("props  ------ Employeetwin page  -----", props);

  const isMobile = useMediaQuery({ query: "(max-width: 720px)" });

  let initialStates = {};
  let [state, setState] = React.useState(initialStates);
  const [submitForm, setSubmitForm] = React.useState(false);
  const [invalidFlag, setInvalidFlag] = React.useState(false);
  const [getFormValues, setGetFormValues] = React.useState(false);
  const [emptyFormValues, setEmptyFormValues] = React.useState(false);
  const [bots, setBots] = React.useState([]);
  const [successModal, setSuccessModal] = React.useState(false);
  const [message, setMessage] = React.useState(
    "We have received your request. Please wait for a while we get back to you."
  );
  const [empModal, setEmpModal] = React.useState(false);
  const [countdata, setCountdata] = useState();
  const [countdata1, setCountdata1] = useState();
  const [noResultFlag, setNoResultFlag] = React.useState(false);
  let initialCezState = {
    0: false,
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
    6: false,
  };

  const [spinner, setspinner] = React.useState(true);
  const [cezState, setCezState] = React.useState({
    ...initialCezState,
    0: true,
  });

  const cezClicked = (index) => {
    //console.log("cezState", cezState, index);
    setCezState({ ...initialCezState, [index]: true });
  };
  const clearALLFilter = () => {
    window.scrollTo(0, 200);
    setState({});
    //setLoadState(true)
    setNoResultFlag(false);

    // dispatch(getBotsAction(0))
    // setAllBots([])
    // setInfiniteKey(infiniteKey + 1)
    // setHasMoreBots(true)
  };

  let initialFeatureImageState = { 0: false, 1: false, 2: false, 3: false };

  const [featureImageState, setFeatureImageState] = React.useState({
    ...initialFeatureImageState,
    0: true,
  });

  const mouseEntered = (index) => {
    setFeatureImageState({ ...initialFeatureImageState, [index]: true });
  };

  // taking data out from drupal
  let imagewithtextComponents = props.data.filter(
    (item) => item.component.type == "image_with_text"
  );
  let carouselComponents = props.data.filter(
    (item) => item.component.type == "home_carousel_component"
  );

  let videoComponent = props.data.filter(
    (item) => item.component.type == "home_video_component"
  );
  const backgroundUrlMobile = _get(
    props.data[0],
    "component.content.field_background_image_mobile[0]",
    ""
  );
  const backgroundUrl = _get(
    props,
    "data[0]component.content.field_background_image[0].file_url",
    ""
  );

  const emptwinDetails = _get(
    props,
    "data[0].component.content.field_details",
    ""
  );
  const emptwinHeading = _get(
    props,
    "data[0]component.content.field_hedaing",
    ""
  );
  const backgroundUrlMobile1 = _get(
    props.data[10],
    "component.content.field_background_image_mobile[0]",
    ""
  );
  const backgroundUrl1 = _get(
    props,
    "data[10]component.content.field_background_image[0].file_url",
    ""
  );

  const emptwinDetails1 = _get(
    props,
    "data[10].component.content.field_details",
    ""
  );
  const emptwinHeading1 = _get(
    props,
    "data[10]component.content.field_hedaing",
    ""
  );
  const backgroundUrlMobileemptwin = _get(
    props.data[11],
    "component.content.field_background_image_mobile[0]",
    ""
  );
  const backgroundUrlemptwin = _get(
    props,
    "data[11]component.content.field_background_image[0].file_url",
    ""
  );
  const {
    field_home_image,
    field_hedaing,
    field_video_icon,
    field_label,
    field_home_video,
  } = videoComponent[0].component.content;
  {/*console.log(
    "videoComponent[0].component.content",
    videoComponent[0].component.content
  );*/}
  let serviceComponent = props.data.filter(
    (item) => item.component.type == "home_service_component"
  );

  const noResultComponent = props.data.filter(
    (item) => item.component.type == "no_result_component"
  )[0];

  const content = _get(props, "data[12]component.content", "");
  //console.log(noResultComponent, "noooooooresultcomponent")

  let featureComponent = props.data.filter(
    (item) => item.component.type == "home_feature_component"
  );

  let botListingComponent = props.data.filter(
    (item) => item.component.type == "home_bot_listing_component"
  )[0].component.content;

  let getInTouchComponent = props.data.filter(
    (item) => item.component.type == "home_get_in_touch_component"
  )[0].component.content;

  const submitRequestDemoForm = () => {
    setGetFormValues(true);
  };

  const recievedFormValues = async (formState) => {
    if (!invalidFlag) {
      setState({ ...state, ...formState });

      //console.log(state);
      setSubmitForm(true);
      setFullPageLoading(true);

      let authCheck = JSON.parse(localStorage.getItem("auth")).data;
      let expiryStatus = await props.checkExpiry(authCheck);

      if (expiryStatus) {
        let auth = JSON.parse(localStorage.getItem("auth")).data;
        axios({
          method: "post",
          url: `${endpoints.baseUrl}/demo/createDemoRequest`,
          headers: {
            Authorization: auth.accessToken,
          },
          data: {
            ...formState,
            ...state,
            UserEmail: auth.email,
          },
        }).then((resp) => {
          if (resp.data.code == 403) {
            localStorage.removeItem("auth");
            sessionStorage.clear();
            setFullPageLoading(false);
            props.sessionTimeOutCheck(true);
            setAlternateBotsLoading(false);

            setGetFormValues(false);
          } else if (resp.data.code == 200) {
            setState(initialState);
            setSuccessModal(true);
            setGetFormValues(false);
            setFullPageLoading(false);
            setEmptyFormValues(!emptyFormValues);
            // setState(initialState);
            document.getElementById("remark").value = "";
          }
        });
      } else {
        setFullPageLoading(false);
        setAlternateBotsLoading(false);
        props.sessionTimeOutCheck(true);
      }
    }
  };

  function openpopup()
  {
    let modal = !empModal;
    setEmpModal(true);
    if (modal === true) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    let auth =  JSON.parse(localStorage.getItem("auth")).data;
        axios({
          method: "POST",
          url: `${endpoints.baseUrl}/twin/randomMail`,
          headers: {
            Authorization: `${auth.accessToken}|${auth.email}`,
          },
          data: {
              "Description": "test",
              "Rating": "test"
          
          },
        }).then((resp) => {
          if (resp.data.code == 403) {
            
          } 
          else if (resp.status == 200) {
           // console.log("data from api---->",resp);
        
          } 
          else if (resp.data.code == 400) {
            
          }
        });

  }


  let leadPlatform = _get(
    props.globalData,
    "lead_platform_main_component[0].field_options",
    []
  );
  React.useEffect(() => {
    leadPlatform = leadPlatform.filter((item, index) => index < 8);

    setleadPlatformData(leadPlatform);
  }, []);

  React.useEffect(async () => {
//console.log(state);
    try {
      let Filters = {};
      let auth = JSON.parse(localStorage.getItem("auth")).data;
      for (let i in auth) {
        //    console.log("i----", i);
        if (
          i == "personalarea" ||
          i == "personalCluster" ||
          i == "personalCountry" ||
          i == "personalLeadPlatform" ||
          i == "personalMco" ||
          i == "personalSubArea"
        ) {
          if (auth[i] != null) {

            if (auth[i].length > 0 && auth[i] != null) {
                 //console.log("auths", auth[i]);
            if (  i == "personalArea" ) {
              Filters.area = auth[i]
            }
            else if ( i == "personalCluster") {
              Filters.cluster = auth[i]
            }
            else if ( i == "personalMco") {
              Filters.mco = auth[i]
            }
            else if ( i == "personalCountry") {
              Filters.country = auth[i]
            }
            else if ( i == "personalSubArea") {
              Filters.subArea = auth[i]
            }
            else if ( i == "personalLeadPlatform") {
              Filters.leadPlatform = auth[i]
            }
            //  console.log(i[8], "filtersssssssssssss", i)
            //   Filters[changeIt(i.slice(8))] = auth[i]; 

            }
          }
        }
      }
      //console.log("auth  ----", auth);

      
       //console.log("Filters", state);
      //  Filters=state;
       //console.log(Object.keys(state).length);
      if (Object.keys(state).length == 0) {
        setShowAlternateBots(true);
        getAlternateBots(leadPlatform[0]);

        console.log("not data");
      }
       else {
        if (!showAlternateBots) {
          Filters = {};
        }
          //console.log('Filters ---', Filters);
          //console.log("data");
        let authCheck = JSON.parse(localStorage.getItem("auth")).data;
        let expiryStatus = await props.checkExpiry(authCheck);

        if (expiryStatus) {
          auth = JSON.parse(localStorage.getItem("auth")).data;
          axios({
            method: "get",
            url: `${endpoints.baseUrl}/elastic/searchQueryTwin`,
            params: state,
            headers: {
              Authorization: auth.accessToken,
            },
          }).then((resp) => {
            if (resp.data.code == 200) {
              //console.log("line number 520",resp)
              // dispatch(saveBotsAction({ data: resp.data.data, filter: "filter" }));
              //    console.log(resp.data.data, "responseDotData  all use effect ")
              if (resp.data.data.allTwinBots.length == 0) {
                //console.log("here  ----", resp.data.data.allTwinBots)
               // setShowAlternateBots(true);
                // getAlternateBots(leadPlatform[0]);
                //     console.log(leadPlatform[0], "leadPlatformData")
           
               setAlternateBots(resp.data.data.allTwinBots);
   } else {
                setAlternateBots(resp.data.data.allTwinBots);
                //console.log(resp.data.data.allTwinBots);
                //setAlternateBots([...resp.data.data.allTwinBots]);
              }
            } else if (resp.data.code == 403) {
              localStorage.removeItem("auth");
              sessionStorage.clear();
              setFullPageLoading(false);
              setAlternateBotsLoading(false);
              props.sessionTimeOutCheck(true);
            } else {
              setShowAlternateBots(true);
              getAlternateBots(leadPlatform[0]);
              //        console.log(leadPlatform[0], "leadPlatformData")
            }
          });
        } else {
          setFullPageLoading(false);
          setAlternateBotsLoading(false);
          props.sessionTimeOutCheck(true);
        }
      }
    } catch (e) {
      console.log(e);
    }
  }, [state]);
//console.log(state);
  // alternatebots

  const [alternateBots, setAlternateBots] = React.useState([]);
  const [showAlternateBots, setShowAlternateBots] = React.useState(false);
  const [alternateBotsLoading, setAlternateBotsLoading] = React.useState(false);
  const [leadPlatformData, setleadPlatformData] = React.useState([]);
  const [fullPageLoading, setFullPageLoading] = React.useState(false);

  const getAlternateBots = async (leadPlatform) => {
    setAlternateBotsLoading(true);

    let authCheck = JSON.parse(localStorage.getItem("auth")).data;
    let expiryStatus = await props.checkExpiry(authCheck);

    if (expiryStatus) {
      let auth = JSON.parse(localStorage.getItem("auth")).data;
      axios({
        method: "get",
        url: `${endpoints.baseUrl}/elastic/searchQueryTwin`,
        headers: {
          Authorization: auth.accessToken,
        },
      }).then((resp) => {
        if (resp.data.code == 200) {
          //console.log("line number 579",resp)
          // dispatch(saveBotsAction({ data: resp.data.data, filter: "filter" }));
          setAlternateBotsLoading(false);
          setAlternateBots(resp.data.data.allTwinBots);
          // console.log("line 608", resp);
        } else if (resp.data.code == 403) {
          localStorage.removeItem("auth");
          setFullPageLoading(false);
          setAlternateBotsLoading(false);
          sessionStorage.clear();
          props.sessionTimeOutCheck(true);
        }
      });
    } else {
      setFullPageLoading(false);
      setAlternateBotsLoading(false);
      props.sessionTimeOutCheck(true);
    }
  };

  const leadPlatformRadioChange = (e) => {
    setDropdownState({ leadPlatform: false });
    setDropdownValue(e.target.value);
    getAlternateBots(e.target.value);
  };

  const [dropDownState, setDropdownState] = React.useState({
    leadPlatform: false,
  });
  const [dropdownValue, setDropdownValue] = React.useState("");
  const handleDropDown = (item) => {
    setDropdownState({
      ...dropDownState,
      [item]: !dropDownState[item],
    });
  };

  // React.useEffect(() => {
  //   getAlternateBots("Customer Development");
  // }, []);

  const goTo = (link) => {
    // console.log(link);
    router.push(link);
  };
  const [video, setvideo] = React.useState(false);

  const handlevideo = () => {
    let modal = !video;
    setvideo(true);

    if (modal === true) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  };


  const [carouselRef, setCarouselRef] = React.useState(null);
  const [carouselAutoplay, setCarouselAutoplay] = React.useState(false);

  const [isPlaying, setIsPlaying] = React.useState(true);

  const sliderChanged = (slideIndex, { currentSlide, onMove }) => {
    // console.log(currentSlide, "currentSlide");
    if (currentSlide == 2) {
      setCarouselAutoplay(false);

      setIsPlaying(true);
    } else {
      setIsPlaying(false);

      setCarouselAutoplay(false);
    }
  };

  const reactRef = React.useRef(null);

  const videoUrl =
    window.innerWidth >= 780
      ? props.data[1].component.content.field_carousel_video[0].file_url
      : _get(
        props,
        "data[1].component.content.field_carousel_video_mobile[1].file_url",
        ""
      );

  const clickedOnVideo = (flag) => {
    if (flag) {
      props.videoClicked();
    }
  };

  const getListItemColor = (index) => {
    if (index === 0) {
      return "#4ba58a";
    }

    if (index === 1) {
      return "#6ec5fa";
    }

    if (index === 2) {
      return "#61d4c4";
    }

    if (index === 3) {
      return "#9149ba";
    }

    if (index === 4) {
      return "#ff7c7d";
    }

    if (index === 5) {
      return "#e45ec2";
    }

    if (index === 6) {
      return "#4068d1";
    }

    return "#4ba58a";
  };

  //console.log("imagessection 1", carouselComponents);
 
  const [twinuser, setTwinuser] = useState(null);

  const localHandler = async (e) => {
    let auth = JSON.parse(localStorage.getItem("auth")).data;
    const { data } = await axios({
      url: `${endpoints.baseUrl}/twin/sumManulAndFte `,
      method: "GET",
      headers: {
        Authorization: `${auth.accessToken}|${auth.email}`,
      },

    });
    //console.log(data);
    if (data.code === 200) {
      const a=data.data;
      setCountdata(a.manualhour);
      setCountdata1(a.fte.toFixed(2));
    }
    else
    {
      console.log("No data found")
    }
  
}
React.useEffect(() => {
  let authCheck = JSON.parse(localStorage.getItem("auth")).data;
    let expiryStatus =  props.checkExpiry(authCheck);
    let auth = JSON.parse(localStorage.getItem("auth")).data;
    axios({
      method: "GET",
      url: `${endpoints.baseUrl}/twin/get`,
      headers: {
        Authorization: `${auth.accessToken}|${auth.email}`,
      },}).then((resp) => {
        setTwinuser(resp.data);
      })
      localHandler();

}, []);
if (!twinuser) return null;
//console.log(countdata);
//console.log("twinuser data", twinuser);
let auth =  JSON.parse(localStorage.getItem("auth")).data;
//console.log(auth.email);
  return (
    <div className={`${styles.landingContainer}`}>
      {successModal ? (
        <SuccessModal
          setSuccessModal={setSuccessModal}
          title={"Request a demo"}
          message={message}
        />
      ) : null}
      <div id="headTop"></div>
      <Empbanner
        data={{
          emptwinDetails,
          emptwinHeading,
          backgroundUrl,
          backgroundUrlMobile,
        }}
        name = "employeetwin"
      />
      {/* <Empbanner1
        data={{
          emptwinDetails1,
          emptwinHeading1,
          backgroundUrl1,
          backgroundUrlMobile1,
        }}
        name = "employeetwin"
      /> */}
      <div className={`${styles.caramain}`}>
        {/* <Carousels
          responsive={responsive1}
          ssr={true}
          arrows={false}
          transitionDuration={300}
          autoPlaySpeed={4000}
          customButtonGroup={<ButtonGroupmain />}
          renderButtonGroupOutside={true}
          showDots={true}
          customDot={<CustomDot />}
          autoPlay={carouselAutoplay}
          infinite
          ref={(el) => setCarouselRef(el)}
          afterChange={sliderChanged}
        > */}
          {/* {carouselComponents.map((item, index) => {
            // fix this
            if (
              _get(item, "component.content.field_input_type", "") == "Image"
            ) {
              return ( */}
                <div className={styles.carousalimage}>
                  <a
                    href={_get(
                      props.data[3],
                      "component.content.field_banner_cta[0].uri",
                      ""
                    )}
                  >
                    <picture>
                      <source
                        media="(max-width: 780px)"
                        srcSet={
                          endpoints.drupalIp +
                          _get(
                            props.data[3],
                            "component.content.field_carousel_image_mobile[0].file_url",
                            ""
                          )
                        }
                      />
                      {/* <source media="(max-width: 768px)" srcset="/assets/svg/carousalMobileImag2.png" />
                        <source media="(max-width: 768px)" srcset="/assets/svg/carousalMobileImag3.png" /> */}
                      <LazyLoadImage
                        src={
                          endpoints.drupalIp +
                          _get(
                            props.data[3],
                            "component.content.field_carousel_image[0].file_url",
                            ""
                          )
                        }
                      />
                        <div className={styles.counting}>
                        <div className={styles.yellow}>
                          <p className={styles.countingpara}>{countdata} Manual Hour Saving</p>
                        </div>
                        <div className={styles.purple}>
                        <p className={styles.countingpara}>{countdata1} FTE Saving</p>
                        </div>
                        <div className={styles.pink}>
                          <p className={styles.countingpara}>24x7 availability<br/>Reduction of manual efforts</p>
                        </div>
                      </div>

                    </picture>

                  </a>

                  {/* <span className={styles.btn}>hii</span> */}
                </div>
              {/* );
            } */}
            
            {/* else if (
              // _get(item, "component.content.field_input_type", "") == "Video"

              name
            ) {
              return (
                <div
                  className={styles.carousalvideo}
                  onClick={() => {
                    clickedOnVideo(true);
                  }}
                >
                  {spinner ? (
                    <div className={styles.videoloader}>
                      <picture>
                        <source
                          media="(max-width: 780px)"
                          srcSet={
                            endpoints.drupalIp +
                            _get(
                              props,
                              "data[0].component.content.field_carousel_video_alt_image_m[0].file_url",
                              ""
                            )
                          }
                        />
                        <LazyLoadImage
                          className={styles.carouselVideoAlt}
                          src={
                            endpoints.drupalIp +
                            _get(
                              props,
                              "data[0].component.content.field_carousel_video_alt_image[0].file_url",
                              ""
                            )
                          }
                        />
                      </picture>
                    </div>
                  ) : null}

                  <ReactPlayer
                    onStart={() => {
                      setspinner(false);
                    }}
                    width="100vw"
                    ref={reactRef}
                    height={spinner ? "0" : "100%"}
                    playing={isPlaying}
                    muted={true}
                    loop={false}
                    onEnded={() => {
                      reactRef.current.seekTo(0);
                      setIsPlaying(false);
                      if (carouselRef) {
                        carouselRef.goToSlide(4);
                      }
                      // setCarouselAutoplay(true);
                    }}
                    url={endpoints.drupalIp + videoUrl}
                  />
                </div>
              );
            } */}
          {/* })} */}
        {/* </Carousels> */}
        
      </div>

      {/* watch video section */}
      <div className={`${styles.mainbanner}`}>
        <div className={styles.secondaryBanner}>
          <img
            src={endpoints.drupalIp + field_home_image[0].file_url}
            className={styles.videoimage}
          />
          <div className={styles.videobox} onClick={handlevideo}>
            <div className={styles.videoicon}>
              {" "}
              <LazyLoadImage
                src={endpoints.drupalIp + field_video_icon[0].file_url}
                alt={field_video_icon[0].image_alt}
              />
            </div>
          </div>
          <button className={styles.submitbtn} onClick={() => {openpopup()}} >Experience Employee Twin </button>
        </div>
        <div className={styles.videocard}>
          <h2 className={styles.emptwinvideotext}>
            {field_hedaing} <span>Team</span>
          </h2>
          <p className={styles.head}>{field_label}</p>
          <ul className={styles.videolist}>
            <li className={styles.videolistli}>The Employee Twin should need to perform core transactions/activities being performed by the team​</li>
            <li className={styles.videolistli}>Human in the Loop, where the output of a bot is validated and then further processed​</li>
            <li className={styles.videolistli}>Need for personalised recommendations​</li>
            <li className={styles.videolistli}>User triggered processes for ad-hoc runs, status checks and Knowledge search </li>
          </ul>
        </div>
      </div>





        {/*New Bot section created for elastic search */}

        {showAlternateBots ? (
        <div className={styles.guestBot}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 mt-5">
                <p className={styles.head}>
                  {_get(botListingComponent, "field_title", "")}
                  <span className={styles.headspan}>Twin</span>
                </p>
                <p className={styles.content}>
                  {_get(botListingComponent, "field_message_input", "")}
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-12 mb-5">
                <div className={`${styles.mainbot} row`}>
                  {!isMobile ? (
                    <div className="col-lg-3">
                      <div className={styles.filterbot}>
                        <p className={styles.headfilter}>
                          {" "}
                          {_get(botListingComponent, "field_label", "")}
                        </p>
                        <div className={styles.radiolanding}>
                          <div
                            className={styles.inputGroupWrapper}
                            onChange={leadPlatformRadioChange}
                          >
                             {/* <select className={styles.select} 
                                    name="leadPlatformRadio" id="leadPlatformRadio">
                                     <option>Select Lead Platform</option>
                            {leadPlatformData.map((item, index) => (

                              <option value={item} key={index}>{item}</option>
                            
                            ))}
                            </select> */}
                            <Filters
                            data={content}
                            clearALLFilter={clearALLFilter}
                            initialStates={initialStates}
                            state={state}
                            setState={setState}
                          />
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="col-lg-3">
                      <div className={styles.colFirst}>
                        <div className={styles.row}>
                          <div>
                            <p
                              className={`${styles.input}`}
                              onClick={() => {
                                handleDropDown("leadPlatform");
                              }}
                            >
                              {/* drupalCheck */}
                              <span className={styles.left}>
                                {dropdownValue == ""
                                  ? _get(botListingComponent, "field_label", "")
                                  : dropdownValue}
                              </span>
                              <span className={styles.right}>
                                <Icons
                                  name="chevron"
                                  className={styles.chevron}
                                />
                              </span>
                            </p>
                            {dropDownState["leadPlatform"] == true ? (
                              <div className={styles.editModalWrapper}>
                                <div className={styles.modalBox}>
                                  <div className={styles.radiolanding}>
                                    <div
                                      className={styles.inputGroupWrapper}
                                      onChange={leadPlatformRadioChange}
                                    >
                                      {leadPlatformData.map((item, index) => (
                                        <label className={styles.radioWrapper}>
                                          <input
                                            type="radio"
                                            className={styles.radioBox}
                                            value={item}
                                            name="leadPlatformRadio"
                                            defaultChecked={
                                              item == dropdownValue
                                                ? true
                                                : false
                                            }
                                          />
                                          <span
                                            className={styles.radioCheckmark}
                                          ></span>
                                          <span className={styles.subLabel}>
                                            {item}
                                          </span>
                                        </label>
                                      ))}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="col-lg-7 col-xl-8">
                    <div className={styles.main}>
                      {alternateBotsLoading ? (
                        <Loader />
                      ) : alternateBots.length == 0 ? (
                        <div className={styles.noresults}>
                          {/* fix this */}
                          <LazyLoadImage
                            src={`${endpoints.drupalIp}${_get(
                              noResultComponent,
                              "component.content.field_no_result_image[0].file_url",
                              ""
                            )}`} />
                          <h3 className={styles.head}>
                             {" "}
                            {_get(
                              noResultComponent,
                              "component.content.field_title",
                              ""
                            )}
                          </h3>
                          <div
                            className={styles.content}
                            dangerouslySetInnerHTML={{
__html: _get(
                                noResultComponent,
                                "component.content.field_details",
                                ""
                              ),}}
                          ></div>
                        </div>
                      ) : alternateBots.length < 3 ? (
                        <div className={styles.alternateBotsLessThan3}>
                          {alternateBots.map((bot, index) => (
                            <div className={styles.botcard}>
                              <Card key={index} data={bot} id={index}/>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <Carousels
                          partialVisible={true}
                          responsive={responsive2}
                          ssr={true}
                          arrows={false}
                          transitionDuration={0}
                          customButtonGroup={<ButtonGroup2 />}
                          renderButtonGroupOutside={true}
                          infinite
                          style={{ width: "100%" }}
                        >
                          {alternateBots.map((bot, index) => (
                            bot._source.employeeTwinName?
                            <div className={styles.botcard}>
                              <Card key={index} data={bot} />
                            </div>
                           :null
                          ))}
                        </Carousels>
                      )}
                    </div>
                  </div>
                </div>
                {props.Etroles.includes(auth.email)?
                <span
                  className={styles.filterbtn1}
                  onClick={() => goTo(props.pageRoutes.CreateEmployeeTwin)}
                >
                  {_get(botListingComponent, "field_input", "")}
                </span>:null
              }
                <span
                  className={styles.filterbtn}
                  onClick={() => goTo(props.pageRoutes.Purchaseemployeetwin)}
                >
                 Purchase Now
                </span>

              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={styles.botstorePage}>
          <div className="container">
            <div className="row">
              <div className="col-12 my-4">
                <p className={styles.head}>
                  Have a look at the{" "}
                  {_get(
                    JSON.parse(localStorage.getItem("auth")),
                    "data.personalLeadPlatform"
                  )}{" "}
                  automations
                </p>
                <p className={styles.content}>
                  {_get(
                    botListingComponent,
                    "field_bot_listing_user_details",
                    ""
                  )}
                </p>
                <div className="">
                  <div className={styles.main}>
                    
                    {/* {
                    bots.length < 3 ? (
                      <div className={styles.alternateBotsLessThan3}>
                        {bots.map((bot, index) => (
                          <div className={styles.botcard}>
                            <Card key={index} data={bot} />
                          </div>
                        ))}
                      </div>
                    ) : 
                    ( */}
                      <Carousels
                        partialVisible={true}
                        responsive={responsive3}
                        ssr={true}
                        arrows={false}
                        transitionDuration={0}
                        customButtonGroup={<ButtonGroup />}
                        renderButtonGroupOutside={true}
                        infinite
                        style={{ width: "100%" }}
                      >
                        {bots.map((bot, index) => (
                          <div className={styles.botcard}>
                            <Card key={index} data={bot} />
                          </div>
                        ))}
                      </Carousels>
                    {/* )} */}
                  </div>
                </div>
                <div
                  className={styles.parentbtn}
                  onClick={() => goTo(props.pageRoutes.BotStore)}
                >
                  <span className={styles.btn}>
                    {_get(botListingComponent, "field_input", "")}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

        {/* */}
      

      <div
        className={`${styles.containerfluidbg} container-fluid d-none d-md-block `}
      >
        <div className={`${styles.contactLanding}`}>
          <div className="row">
            <div className="col-12">
              <p className={styles.head}>
                {_get(getInTouchComponent, "field_title", "")}
              </p>
              <p className={styles.text}>
                {_get(getInTouchComponent, "field_message_input", "")}
              </p>
              <a
                className={styles.btn}
                href="mailto:automation.factory@unilever.com"
              >
                {_get(getInTouchComponent, "field_label", "")}
              </a>
              <div className={styles.image}>
                <LazyLoadImage
                  src={
                    endpoints.drupalIp +
                    _get(
                      getInTouchComponent,
                      "field_get_in_touch_image[0].file_url",
                      ""
                    )
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={`${styles.contactLanding} d-md-none`}>
        <p className={styles.head}>
          {_get(getInTouchComponent, "field_title", "")}
        </p>
        <p className={styles.text}>
          {_get(getInTouchComponent, "field_message_input", "")}
        </p>
        <a className={styles.btn} href="mailto:sanjay.sharma@unilever.com">
          {_get(getInTouchComponent, "field_label", "")}
        </a>
        <div className={styles.image}>
          <LazyLoadImage
            src={
              endpoints.drupalIp +
              _get(
                getInTouchComponent,
                "field_get_in_touch_image[0].file_url",
                ""
              )
            }
          />
        </div>
      </div>
      {video ? (
        <Video
          closeModal={() => {
            setvideo(false);
          }}
          name="emptwin"
        />
      ) : null}
      {
        empModal ? (
          <ExperienceemptwinModal
            data={props.softskill.data.field_component}
            closeModal={() => {
              setEmpModal(false);
            }}
            pageRoutes={props.pageRoutes}
           
          />
        ) : null
      }
    </div>
  );
}

const mapStateToProps = (state) => {
  //console.log("state", state);
  return {
    session: state.session.session,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    sessionTimeOutCheck: bindActionCreators(sessionTimeOutCheck, dispatch),
    checkExpiry: bindActionCreators(checkExpiry, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(index);

